import { render, staticRenderFns } from "./AnswerLinkedQuestion.vue?vue&type=template&id=6e7ec1d0"
import script from "./AnswerLinkedQuestion.vue?vue&type=script&lang=js"
export * from "./AnswerLinkedQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports